/**
 * Elfink header — Markets country disclosure + form submit.
 * Standalone; does not modify theme.js.
 */
(function () {
  if (window.__ehCountryInit) return;
  window.__ehCountryInit = true;

  function closeAll(except) {
    document.querySelectorAll('[data-eh-country].is-open').forEach(function (root) {
      if (except && root === except) return;
      setOpen(root, false);
    });
  }

  function setOpen(root, open) {
    var toggle = root.querySelector('[data-eh-country-toggle]');
    var panel = root.querySelector('[data-eh-country-panel]');
    if (!toggle || !panel) return;
    root.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      panel.removeAttribute('hidden');
      panel.style.display = '';
    } else {
      panel.setAttribute('hidden', 'hidden');
      panel.style.display = 'none';
    }
  }

  function submitCountry(root, iso) {
    var form = root.querySelector('form');
    var input = root.querySelector('[data-eh-country-input]');
    if (!form || !input || !iso) return;
    input.value = iso;
    form.submit();
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-eh-country-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      var root = toggle.closest('[data-eh-country]');
      if (!root) return;
      var willOpen = !root.classList.contains('is-open');
      closeAll(willOpen ? root : null);
      setOpen(root, willOpen);
      return;
    }

    var option = e.target.closest && e.target.closest('[data-eh-country-option]');
    if (option) {
      e.preventDefault();
      e.stopPropagation();
      var optRoot = option.closest('[data-eh-country]');
      if (!optRoot) return;
      var value = option.getAttribute('data-value');
      if (option.classList.contains('is-selected')) {
        setOpen(optRoot, false);
        return;
      }
      submitCountry(optRoot, value);
      return;
    }

    if (!e.target.closest || !e.target.closest('[data-eh-country]')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();
